export default __webpack_public_path__ + "static/media/product-3.be78b996.png";